export default {
  text: '{{threshold}} ventes mensuelles : {{amount}}',
  label: '{{threshold}} ventes mensuelles :',
  no_discount: 'aucune remise',
  discount_badge: '-{{percentage}}%',
};
